import { useCookie, defineNuxtPlugin } from 'nuxt/app';
import { Cookies } from '@pkg/analytics-helper/src/constants/cookies';
import { gtmCookieDomain, usesLiveGtmReferrer } from '@pkg/analytics-helper/src/utilities/gtmCookieDomain';
import { logger } from '@pkg/logger';
import { referrerLookupTable } from '~/utils/referrerData';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    try {
      const { public: { domain } } = useRuntimeConfig();
      const myCookie = useCookie(Cookies.GTM_CAMPAIGN, { domain: gtmCookieDomain(domain) });

      const hasUtmMediumParam: boolean = !!myCookie.value?.includes('utm_medium');
      const hasUtmSourceParam: boolean = !!myCookie.value?.includes('utm_source');

      let referrerValue = document.referrer;

      if (!usesLiveGtmReferrer(domain)) {
        const debugCookie = useCookie('debugfallback');
        referrerValue = debugCookie.value || '';
      }

      const referrer = referrerValue ? getDomainWithoutProtocol(referrerValue) : undefined;

      if ((!hasUtmMediumParam || !hasUtmSourceParam) && referrer) {
        const lookup = referrerLookupTable[referrer]?.split('---') || {};

        if (lookup.length > 1) {
          let medium: string | undefined;
          let source: string | undefined;

          if (!hasUtmMediumParam) {
            medium = `utm_medium=${lookup[0]?.toLocaleLowerCase() || referrer}`;
          }

          if (!hasUtmSourceParam) {
            source = `utm_source=organic_${lookup[1]?.toLocaleLowerCase() || referrer}`;
          }
          updateCookieWithFallbacks(domain, medium, source);
        }
      }
    } catch (error) {
      logger.error('Error parsing utm source fallback ', error);
    }
  });
});

const updateCookieWithFallbacks = (domain: string, medium?: string, source?: string) => {
  const myCookie = useCookie(Cookies.GTM_CAMPAIGN, { domain: gtmCookieDomain(domain) });

  const route = useRoute();
  const fullUrlWithoutQuery = encodeURIComponent(window.location.origin + route.path) || '';

  const currentCookieValue = myCookie.value || fullUrlWithoutQuery;
  const separator = currentCookieValue.includes('?') ? '&' : '?';

  myCookie.value = currentCookieValue + separator + medium + (source ? (medium ? '&' : separator) + source : '');
};

function getDomainWithoutProtocol(url: string) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.host;
  } catch (error) {
    logger.error('Error parsing source URL ', error);
    return url;
  }
}
